module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getConfData.showPopup) ? _c('div', {
    staticClass: "confirmation-popup",
    attrs: {
      "role": "dialog"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.clearAction($event)
      }
    }
  }, [_c('div', {
    staticClass: "confirmation-popup-inner",
    attrs: {
      "id": "alertPopup",
      "aria-labelledby": "confirmation-popup-title",
      "aria-modal": "true"
    }
  }, [_c('h2', {
    staticClass: "confirmation-popup-inner-caption",
    attrs: {
      "id": "confirmation-popup-title"
    }
  }, [_c('span', [_vm._v(_vm._s(this.getActionNotifyText(_vm.getConfData.actionName, _vm.getConfData.userStatus)['title']))])]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-popup-inner-body"
  }, [_c('span', [_vm._v(_vm._s(this.getActionNotifyText(_vm.getConfData.actionName, _vm.getConfData.userStatus)['body']))]), _vm._v(" "), (_vm.getConfData.includeForm) ? _c('div', {
    staticClass: "confirmation-popup-inner-body__form"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getConfData.feedbackText),
      expression: "getConfData.feedbackText"
    }],
    staticClass: "form-control form-control__textarea",
    domProps: {
      "value": (_vm.getConfData.feedbackText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getConfData, "feedbackText", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-popup-inner-controll-panel"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearAction
    }
  }, [_vm._v(_vm._s(_vm.getConfData.customCancelButtonText || 'No, cancel'))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.confirmAction($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.getConfData.customConfirmButtonText || 'Yes, proceed'))])]), _vm._v(" "), _c('button', {
    staticClass: "confirmation-popup-close",
    attrs: {
      "aria-label": "Close dialog"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.clearAction($event)
      }
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06aa37ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ConfPopup.vue
// module id = 936
// module chunks = 0